module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av405-85195b9679c867a6f31f4ecf6b7b0eed.jpg";